export {
  isUndoRedo,
  isCleanDocument,
  isResizing,
  isAgent,
  isBackendAgent,
  isLayoutShift,
} from './update-message.ts';
